import React from 'react'
import { Img } from 'styles/GlobalStyle';
import { CartoonItem, FormFieldStyles, WrapCartoon, WrapForm, WrapFormFields } from './Style';
import { useMediaQuery } from '@mui/material';
import { Button } from 'components/Form';
import { app } from 'router/routes';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthWithCartoon = (props) => {
    const { children, cartoon, cartoonSize, hideAuthTab } = props
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'), { noSsr: true })
    const isLoginScreen = pathname == app.login

    const goLogin = () => navigate(app.login)
    const goRegister = () => navigate(app.schoolRegistartion)


    return (
        <>
            <WrapForm>
                <FormFieldStyles hideAuthTab={hideAuthTab}>
                    {hideAuthTab ||
                        <div className='header'>
                            <div className='login-or-registration'>
                                <Button action={goLogin} color={isLoginScreen ? "dark" : "white"} fullWidth size="small" label="כבר רשומים? התחברו" />
                                <Button action={goRegister} color={isLoginScreen ? "white" : "dark"} fullWidth size="small" label="עוד לא רשומים? הרשמו" />
                            </div>
                        </div>}
                    <div className='content'>
                        <div className='form-content'>
                            {children}
                        </div>
                    </div>
                </FormFieldStyles>
                {!isSmallScreen &&
                    <WrapCartoon>
                        <CartoonItem {...cartoonSize}>
                            <Img src={cartoon} />
                        </CartoonItem>
                    </WrapCartoon>}
            </WrapForm>
        </>
    )
}

export default AuthWithCartoon